import { proxy } from "valtio";

export const meshParts = [
  "top",
  "bot",
  "other",
  "topRoughness",
  "botRoughness",
  "topMetallic",
  "botMetallic",
  "otherMetallic",
  "topNormal",
  "botNormal",
  "otherNormal",
];

export const materialsAlaM = [
  {
    preview: "#4348AB",
    texture: {
      top: "01_Drago/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "01_Drago/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "01_Drago/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "01_Drago/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "01_Drago/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "01_Drago/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "01_Drago/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "01_Drago/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "01_Drago/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "01_Drago/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "01_Drago/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "01_Drago/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
  {
    preview: "#80C670",
    texture: {
      top: "02_Verde/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "02_Verde/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "02_Verde/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "02_Verde/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "02_Verde/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "02_Verde/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "02_Verde/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "02_Verde/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "02_Verde/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "02_Verde/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "02_Verde/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "02_Verde/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
  {
    preview: "#F3BF6E",
    texture: {
      top: "03_Fiamme/Base_sopra.jpg",
      bot: "03_Fiamme/Base_sotto.jpg",
      other: "03_Fiamme/BaseAltro.jpg",
      topRoughness: "03_Fiamme/rawness_sopra.jpg",
      botRoughness: "Normal_Base.jpg",
      otherRoughness: "Normal_Base.jpg",
      topMetallic: "Normal_Base.jpg",
      botMetallic: "Normal_Base.jpg",
      otherMetallic: "03_Fiamme/OTHERS_Metallic.jpg",
      topNormal: "03_Fiamme/NORMAL_sopra.jpg",
      botNormal: "Normal_Base.jpg",
      otherNormal: "03_Fiamme/normal_altro.jpg",
    },
  },
  {
    preview: "#E34F65",
    texture: {
      top: "04_Labyrinth/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "04_Labyrinth/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "04_Labyrinth/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "04_Labyrinth/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "04_Labyrinth/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "04_Labyrinth/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "04_Labyrinth/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "04_Labyrinth/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "04_Labyrinth/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "04_Labyrinth/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "04_Labyrinth/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "04_Labyrinth/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
  {
    preview: "#B77FC5",
    texture: {
      top: "05_Fluo/FLYER_definitivo_SOPRA_BaseColor.jpg",
      bot: "05_Fluo/FLYER_definitivo_SOTTO_BaseColor.jpg",
      other: "05_Fluo/FLYER_definitivo_ALTRO_BaseColor.jpg",
      topRoughness: "05_Fluo/FLYER_definitivo_SOPRA_Roughness.jpg",
      botRoughness: "05_Fluo/FLYER_definitivo_SOTTO_Roughness.jpg",
      otherRoughness: "05_Fluo/FLYER_definitivo_ALTRO_Roughness.jpg",
      topMetallic: "05_Fluo/FLYER_definitivo_SOPRA_Metallic.jpg",
      botMetallic: "05_Fluo/FLYER_definitivo_SOTTO_Metallic.jpg",
      otherMetallic: "05_Fluo/FLYER_definitivo_ALTRO_Metallic.jpg",
      topNormal: "05_Fluo/FLYER_definitivo_SOPRA_Normal.jpg",
      botNormal: "05_Fluo/FLYER_definitivo_SOTTO_Normal.jpg",
      otherNormal: "05_Fluo/FLYER_definitivo_ALTRO_Normal.jpg",
    },
  },
];

export const state = proxy({
  intro: true,
  color: materialsAlaM[0].preview,
  texture: materialsAlaM[0].texture,
  scrollY:0
});
